// Live-updates every "free shipping by quantity" progress bar on the page
// (cart drawer + cart page render one each) when the cart changes, using
// Horizon's native cartLinesUpdate event — no polling, no reload.
import { StandardEvents } from '@shopify/events';

(function () {
  function computeState(itemCount, threshold, progressTemplate, completeTemplate, justAddedTemplate) {
    var remaining = threshold - itemCount;
    if (remaining < 0) remaining = 0;

    var isComplete = itemCount >= threshold;
    var percent = Math.min(100, Math.round((itemCount / threshold) * 100));

    var template = isComplete ? completeTemplate : justAddedTemplate || progressTemplate;
    var text = template
      .split('{{ remaining }}')
      .join(String(remaining))
      .split('{{ threshold }}')
      .join(String(threshold));

    return { isComplete: isComplete, percent: percent, text: text };
  }

  function updateBar(bar, itemCount, justAdded) {
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 2;
    var progressTemplate = bar.getAttribute('data-progress-text') || '';
    var completeTemplate = bar.getAttribute('data-complete-text') || '';
    var addedTemplate = justAdded ? bar.getAttribute('data-added-text') || '' : null;
    var state = computeState(itemCount, threshold, progressTemplate, completeTemplate, addedTemplate);

    var textEl = bar.querySelector('[data-squishy-shipping-text]');
    var fillEl = bar.querySelector('[data-squishy-shipping-fill]');
    var wasComplete = bar.classList.contains('is-complete');

    if (textEl) textEl.textContent = state.text;
    if (fillEl) fillEl.style.width = state.percent + '%';
    bar.classList.toggle('is-complete', state.isComplete);

    if (state.isComplete && !wasComplete) {
      bar.classList.remove('squishy-shipping-celebrate');
      requestAnimationFrame(function () {
        bar.classList.add('squishy-shipping-celebrate');
      });
    }
  }

  function updateAllBars(itemCount, justAdded) {
    document.querySelectorAll('[data-squishy-shipping-bar]').forEach(function (bar) {
      updateBar(bar, itemCount, justAdded);
    });
  }

  function updateBadge(badge, itemCount) {
    var threshold = parseInt(badge.getAttribute('data-threshold'), 10) || 2;
    var remaining = threshold - itemCount;
    var badgeTemplate = badge.getAttribute('data-badge-text') || '';
    var almostText = badge.getAttribute('data-almost-text') || '';
    var completeTemplate = badge.getAttribute('data-complete-text') || '';
    var textEl = badge.querySelector('[data-squishy-free-shipping-badge-text]');
    if (!textEl) return;

    var text;
    if (remaining <= 0) {
      text = completeTemplate.split('{{ threshold }}').join(String(threshold));
    } else if (remaining === 1) {
      text = almostText;
    } else {
      text = '🚚 ' + badgeTemplate.split('{{ threshold }}').join(String(threshold));
    }
    textEl.textContent = text;
  }

  function updateAllBadges(itemCount) {
    document.querySelectorAll('[data-squishy-free-shipping-badge]').forEach(function (badge) {
      updateBadge(badge, itemCount);
    });
  }

  document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
    if (!event.promise) return;
    var justAdded = event.action === 'add';
    event.promise
      .then(function (result) {
        var cart = result && result.cart;
        var detail = result && result.detail;
        var itemCount = cart && typeof cart.totalQuantity === 'number' ? cart.totalQuantity : detail && detail.itemCount;
        if (typeof itemCount === 'number') {
          updateAllBars(itemCount, justAdded);
          updateAllBadges(itemCount);
        }
      })
      .catch(function (error) {
        if (error && error.name !== 'AbortError') {
          console.warn('[squishy-free-shipping-bar] Event promise rejected:', error);
        }
      });
  });
})();
